import { distance2, interpolate } from "@/math/coordinates";
import type { ViewportCoordinate } from "@/model/coordinates";
import { pointer, otherPointer } from "@/utils/dom/pointer";

import { processZoom } from "./zoom";

interface PinchZoom {
  a: number;
  b: number;
  dist: number;
}

let pinchZoom: PinchZoom | undefined;

export function isPinching(id?: number) {
  return !!pinchZoom && (id === pinchZoom.a || id === pinchZoom.b);
}

export function handlePinchPointerDown(id: number, pos: ViewportCoordinate) {
  const other = otherPointer(id);
  if (other) {
    const dist = distance2(other.pos, pos);
    pinchZoom = { a: other.id, b: id, dist };
  }
}

export function handlePinchPointerMove(id: number) {
  if (pinchZoom && isPinching(id)) {
    const pa = pointer(pinchZoom.a)!.pos;
    const pb = pointer(pinchZoom.b)!.pos;
    const dist = distance2(pa, pb);
    const f = Math.sqrt(dist / pinchZoom.dist);
    if (Math.abs(f - 1) > 0.01) {
      processZoom(interpolate(0.5, pa, pb), f, "absolute");
    }
  }
}

export function handlePinchPointerUp(id: number) {
  if (isPinching(id)) {
    pinchZoom = undefined;
  }
}
